import { defineComponent as c, openBlock as t, createBlock as l, unref as n, mergeProps as r, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const f = /* @__PURE__ */ c({
  name: "IconDealFilled",
  __name: "IconDealFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (d, e) => (t(), l(n(m), r(o, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", {
          "fill-rule": "evenodd",
          d: "M9.973 4.063c.951-1.418 3.103-1.418 4.054 0A1 1 0 0 0 15.2 4.43c1.634-.608 3.375.611 3.28 2.297a.95.95 0 0 0 .725.961c1.693.435 2.357 2.407 1.253 3.717a.92.92 0 0 0 0 1.19c1.104 1.31.44 3.282-1.253 3.716a.95.95 0 0 0-.724.962c.094 1.686-1.647 2.905-3.28 2.297a1 1 0 0 0-1.174.367c-.951 1.418-3.103 1.418-4.054 0A1 1 0 0 0 8.8 19.57c-1.634.608-3.375-.611-3.28-2.297a.95.95 0 0 0-.725-.962c-1.692-.434-2.357-2.406-1.253-3.716a.92.92 0 0 0 0-1.19c-1.104-1.31-.44-3.282 1.253-3.717A.95.95 0 0 0 5.52 6.727C5.425 5.04 7.166 3.822 8.8 4.43a1 1 0 0 0 1.173-.367m4.9 8.86c-1.058 0-1.915.827-1.915 1.847s.857 1.845 1.915 1.845 1.915-.826 1.915-1.845-.857-1.847-1.915-1.847m1.412-4.921a.636.636 0 0 0-.854 0L7.715 15.2a.54.54 0 0 0 0 .798.636.636 0 0 0 .854 0l7.716-7.2a.54.54 0 0 0 0-.796M9.127 7.384c-1.058 0-1.915.827-1.915 1.846s.857 1.847 1.915 1.847 1.915-.827 1.915-1.847-.857-1.846-1.915-1.846",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
